import { useState, useRef } from 'react'
import { Link as LinkNative } from 'react-router-dom'
import {
  IconButton,
  ImageList,
  ImageListItem,
  useTheme,
  ImageListItemBar,
  Link,
  useMediaQuery,
  Button,
} from '@mui/material'
import ControlPoint from '@mui/icons-material/ControlPoint'

import { getStockVideoLinks, getLowestQualityVideoLink } from 'src/common/utils'
import { ISetStockVideo, IStockVideoDto, IStockVideoFileDto } from 'src/types'
import { useStyles } from './styles'
import { PlayButtonIcon } from 'src/assets/icons'
import { PEXELS_URL } from 'src/constants'

interface IProps {
  items: IStockVideoDto[]
  setVideo?: ISetStockVideo
}

export const VideosList = ({ items, setVideo }: IProps) => {
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState<number | null>(null)
  const videoRefs = useRef<{ [key: number]: HTMLVideoElement }>({})
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleVideoChoose = (videoFiles: IStockVideoFileDto[]) => () => {
    if (setVideo) {
      const videoLinks = getStockVideoLinks(videoFiles)
      setVideo(videoLinks)
    }
  }

  const handlePlayButtonClick = (videoId: number) => {
    if (currentPlayingVideo === videoId) {
      const videoElement = videoRefs.current[videoId]
      if (videoElement) {
        videoElement.pause()
        setCurrentPlayingVideo(null)
      }
    } else {
      if (currentPlayingVideo !== null) {
        const prevVideoElement = videoRefs.current[currentPlayingVideo]
        if (prevVideoElement) {
          prevVideoElement.pause()
        }
      }

      const videoElement = videoRefs.current[videoId]
      if (videoElement) {
        videoElement.play()
        setCurrentPlayingVideo(videoId)
      }
    }
  }

  return (
    <div className={classes.imageListWrapper}>
      <ImageList className={classes.imagesList} cols={isTablet ? 1 : 2}>
        {items.map((item) => (
          <ImageListItem className={classes.imageItem} cols={isTablet ? 2 : 1} key={item.id}>
            <video
              className={classes.video}
              ref={(el) => {
                if (el) {
                  videoRefs.current[item.id] = el
                }
              }}
              muted
              disablePictureInPicture
            >
              <source src={getLowestQualityVideoLink(item)} type="video/mp4" />
            </video>
            <Button
              className={classes.playButton}
              sx={{
                display: currentPlayingVideo === item.id ? 'none' : 'flex',
              }}
              onClick={() => handlePlayButtonClick(item.id)}
            >
              <PlayButtonIcon />
            </Button>
            <ImageListItemBar
              sx={{ alignItems: 'center', '.MuiImageListItemBar-titleWrap': { padding: 0 } }}
              classes={{ actionIcon: classes.imageActionBtnWrapper }}
              subtitle={
                <span>
                  Video by&nbsp;
                  <Link to={item.user.url} target="_blank" component={LinkNative}>
                    {item.user.name}
                  </Link>
                  &nbsp;on&nbsp;
                  <Link to={PEXELS_URL} target="_blank" component={LinkNative}>
                    Pexels
                  </Link>
                </span>
              }
              actionIcon={
                <IconButton onClick={handleVideoChoose(item.video_files)}>
                  <ControlPoint color="primary" />
                </IconButton>
              }
              position="below"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  )
}
